export default __webpack_public_path__ + "static/media/regulatory--end-of-no-parking--g2.8c4dba58.png";